export const HOME = { emergentLink: "emergent-link" };

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-btn",
  ssoButton: "login-microsoft-sso-btn",
  logoutButton: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard",
  businessUnits: "nav-business-units",
  templates: "nav-templates",
  reviews: "nav-reviews",
  settings: "nav-settings",
  notifications: "nav-notifications",
};

export const SETTINGS = {
  tabFiscal: "settings-tab-fiscal",
  tabTimezone: "settings-tab-timezone",
  tabIntegrations: "settings-tab-integrations",
  tabEmailRouting: "settings-tab-email",
  tabRating: "settings-tab-rating",
  tabPerspectives: "settings-tab-perspectives",
  tabUsers: "settings-tab-users",
  saveButton: "settings-save-btn",
};

export const BU = {
  newBtn: "bu-new-btn",
  tabDepartments: "bu-tab-departments",
  tabTemplates: "bu-tab-templates",
  tabReviews: "bu-tab-reviews",
};

export const TEMPLATE = {
  newBtn: "template-new-btn",
  importBtn: "template-import-btn",
  submitBtn: "template-submit-btn",
  ownerApproveBtn: "template-owner-approve-btn",
  superApproveBtn: "template-super-approve-btn",
  saveBtn: "template-save-btn",
  addRowBtn: "template-add-row-btn",
};

export const REVIEW = {
  startBtn: "review-start-btn",
  submitManagerBtn: "review-submit-manager-btn",
  submitEmployeeBtn: "review-submit-employee-btn",
  submitFinalBtn: "review-submit-final-btn",
};

export const SIGN = {
  tabType: "sign-tab-type",
  tabDraw: "sign-tab-draw",
  tabUpload: "sign-tab-upload",
  clearBtn: "sign-clear-btn",
};
